export enum FeatureFlags {
  UPSELL_AB_TEST = "upsell-ab-test",
  ASYNC_CHECKOUT = "async-checkout",
  COFFEE_LOYALTY = "coffee-loyalty",
  IN_APP_DELIVERY = "in-app-delivery",
}
